import { Fragment, type ReactNode } from "react";
import ParticipantFlowPanel from "@/features/participant/components/ParticipantFlowPanel";
import ParticipantSectionHeading from "@/features/participant/components/ParticipantSectionHeading";
import SurveyScaleSlider from "@/features/participant/components/SurveyScaleSlider";
import type { ParticipantSurveyItem } from "@/features/participant/components/participantSurvey";
import { cn } from "@/lib/utils";

type ParticipantSurveySectionProps = {
  headingId?: string;
  title?: string;
  description?: string;
  items: ParticipantSurveyItem[];
  footer?: ReactNode;
  className?: string;
  headerClassName?: string;
  contentClassName?: string;
  footerClassName?: string;
};

export default function ParticipantSurveySection({
  headingId,
  title,
  description,
  items,
  footer,
  className,
  headerClassName,
  contentClassName,
  footerClassName,
}: ParticipantSurveySectionProps) {
  return (
    <ParticipantFlowPanel
      className={className}
      aria-labelledby={headingId}
      data-participant-survey=""
    >
      {title ? (
        <ParticipantSectionHeading
          id={headingId}
          title={title}
          description={description}
          className={headerClassName}
        />
      ) : null}

      <div className={cn("mt-4 grid gap-3 xl:gap-4", contentClassName)}>
        {items.map((item, index) => (
          <Fragment key={item.id}>
            <SurveyScaleSlider
              label={item.label}
              sub={item.sub}
              value={item.value}
              onChange={item.onChange}
              lowLabel={item.lowLabel}
              highLabel={item.highLabel}
              compact
            />
            {index < items.length - 1 ? (
              <div className={"theme-divider-muted border-t"} />
            ) : null}
          </Fragment>
        ))}
      </div>

      {footer ? (
        <div
          className={cn(
            "theme-divider-muted mt-auto grid gap-4 border-t pt-4",
            footerClassName,
          )}
        >
          {footer}
        </div>
      ) : null}
    </ParticipantFlowPanel>
  );
}
